import { getLatestMovies } from "@/utils/movie";
import MovieCard from "@/components/feature/MovieCard";
import SectionHeading from "@/components/feature/SectionHeading";

export default function LatestSection() {
  const list = getLatestMovies(10);
  return (
    <section className="max-w-[1280px] mx-auto px-4 md:px-8 py-12 md:py-16">
      <SectionHeading
        eyebrow="New Arrivals"
        title="最新收录影视"
        subtitle="持续更新，第一时间收录近期上线与热门影视作品"
        moreLabel="查看全部"
        morePath="/category?sort=latest"
      />
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3 md:gap-5">
        {list.map((m: any) => (
          <MovieCard key={m.id} movie={m} />
        ))}
      </div>
    </section>
  );
}